import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: 'none',
    border: '1px solid #C6C6C6',
    borderTop: '1px solid #C6C6C6',
    borderRight: '1px solid #C6C6C6',
    borderBottom: '1px solid #C6C6C6',
    borderLeft: '1px solid #C6C6C6',
    marginBottom: '10px',
  },
  tableWrapper: {
    width: "100%",
    // Defaults only, and they apply just when no height could be worked out.
    // GenericTable sets maxHeight and overflow INLINE once it knows the space
    // available, because the column headers are sticky and sticky needs a
    // scrolling ancestor with room to hold over. Inline wins over these, so the
    // table scrolls its own rows in the normal case and only falls back to
    // flowing at its natural size here.
    overflowX: "visible",
    overflowY: "visible",
    maxHeight: 'none',
  },
  table: {
    minWidth: 650,
  },
  // Sticky is declared here (not left to MUI's `stickyHeader` defaults) so the
  // opaque #F9F9FC background wins over MUI's theme background and rows don't
  // show through while scrolling.
  headerCell: {
    backgroundColor: '#F9F9FC',
    fontWeight: "bold",
    padding: '10px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    // A sticky cell keeps its background but NOT its borders — the border is
    // painted on the table, which scrolls underneath. Drawn as an inset shadow
    // instead so the line under the headers travels with them; without it the
    // first scrolled row meets the header with no divider at all.
    borderBottom: 'none',
    boxShadow: 'inset 0 -1px 0 #C6C6C6',
  },
  tableCell: {
    padding: '10px',
    borderBottom: '1px solid #C6C6C6',
  },
  uomCell: {
    padding: '10px',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid #C6C6C6',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  pdfLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

